import { render, staticRenderFns } from "./BackupStorageCreate.vue?vue&type=template&id=2ad0a70b"
import script from "./BackupStorageCreate.vue?vue&type=script&lang=js"
export * from "./BackupStorageCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports